export enum TendersStatus {
	active = 'active',
	approved = 'approved',
	timeout = 'timeout',
	draft = 'draft',
	completed = 'completed',
	quoted = 'quoted',
	awarded = 'awarded',
	lost = 'lost',
	expired = 'expired',
	rejected = 'rejected'
}

export enum MultipleDeliveryUnit {
	daily = 0,
	weekly,
	biWeekly,
	monthly,
	quarterly
}

export enum MultipleDeliveryAmount {
	year = 0,
	halfYear,
	quarter
}

export enum TrackChanges {
	tender = 1,
	quotation = 2
}

export enum AIParseProducts {
	pdf = 'pdf',
	doc = 'doc',
	excel = 'excel'
}
